import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { Image, Col, Row, Modal, Button } from "react-bootstrap";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
  ReusableOnboardingMapButton,
} from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { IconButton } from "@material-ui/core";
import { connect } from "react-redux";
import { get_category_menu_setup } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import PropTypes from "prop-types";
import { edit_category_menu_setup } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction";
import Alert from "react-s-alert";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";

const CrossSelling = (props) => {
  let history = useHistory();
  const [category, setCategory] = useState([]);
  const [filteredCategory, setFilteredCategory] = useState([]);
  const [selectedCategoryTypeId, setSelectedCategoryTypeId] = useState();
  const [
    selectedCrossSellingCategoryTypeId,
    setSelectedCrossSellingCategoryTypeId,
  ] = useState([]);

  const onChangeCategoryType = (id) => {
    setSelectedCategoryTypeId(id);
    setSelectedCrossSellingCategoryTypeId([]);
    let filteredData = props.menuCategory.filter((item) => {
      return item._id !== id && !item.is_temp_local;
    });
    setFilteredCategory(filteredData);
  };

  const onClickChangeCrossSellingCategoryType = (id) => {
    if (selectedCrossSellingCategoryTypeId.includes(id)) {
      let filterData = selectedCrossSellingCategoryTypeId.filter((item) => {
        return item !== id;
      });
      setSelectedCrossSellingCategoryTypeId(filterData);
    } else {
      setSelectedCrossSellingCategoryTypeId([
        ...selectedCrossSellingCategoryTypeId,
        id,
      ]);
    }
  };

  const [deleteItem, setDeleteItem] = useState(false);
  const [deleteCategoryId, setDeleteCategoryId] = useState();
  const closeDeleteItem = () => setDeleteItem(false);

  const onClickDeleteItem = (item) => {
    setDeleteCategoryId(item.mainCategoryId);
    setDeleteItem(true);
  };

  const handleDeleteItem = (e) => {
    e.preventDefault();
    const token = props.auth.user.accessToken;
    let formData = {};
    formData.cross_selling = {
      category: [],
    };
    let msg = "Cross Selling Deleted Sucessfully";
    props.edit_category_menu_setup(
      deleteCategoryId,
      formData,
      token,
      onSuccess,
      msg
    );
  };

  const onSuccess = () => {
    setSelectedCategoryTypeId();
    setSelectedCrossSellingCategoryTypeId([]);
    setFilteredCategory([]);
    getLatestData();
    closeDeleteItem();
  };

  const onClickSaveAndAddAnother = () => {
    if (!selectedCategoryTypeId) {
      Alert.error(`<h4> Please select category type</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (selectedCrossSellingCategoryTypeId.length === 0) {
      Alert.error(`<h4> Please select cross selling category type</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const token = props.auth.user.accessToken;
      let formData = {};
      formData.cross_selling = {
        category: selectedCrossSellingCategoryTypeId,
        category_type: selectedCategoryTypeId,
      };
      let msg = "Cross Selling Updated Sucessfully";
      props.edit_category_menu_setup(
        selectedCategoryTypeId,
        formData,
        token,
        onSuccess,
        msg
      );
    }
  };

  const onSuccesstakeToMenu = () => {
    if (history.location.pathname.includes("/fastfood/menusetup")) {
      history.push("/fastfood/menusetup");
    } else if (history.location.pathname.includes("/multi-service/menusetup")) {
      history.push("/multi-service/menusetup");
    } else {
      history.push("/casual-fine-dining/menusetup");
    }
  };

  const onClickProceed = () => {
    if (!selectedCategoryTypeId && category.length === 0) {
      Alert.error(`<h4> Please select category type</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (
      selectedCategoryTypeId &&
      selectedCrossSellingCategoryTypeId.length === 0
    ) {
      Alert.error(`<h4> Please select cross selling category type</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (
      selectedCategoryTypeId &&
      selectedCrossSellingCategoryTypeId.length > 0
    ) {
      const token = props.auth.user.accessToken;
      let formData = {};
      formData.cross_selling = {
        category: selectedCrossSellingCategoryTypeId,
        category_type: selectedCategoryTypeId,
      };
      let msg = "Cross Selling Updated Sucessfully";
      props.edit_category_menu_setup(
        selectedCategoryTypeId,
        formData,
        token,
        onSuccesstakeToMenu,
        msg
      );
    } else if (category.length === 0) {
      Alert.error(
        `<h4> Please add atleast one cross selling category type</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
    } else {
      onSuccesstakeToMenu();
    }
  };

  const editCrossSelling = (item) => {
    onChangeCategoryType(item.mainCategoryId);
    setSelectedCategoryTypeId(item.mainCategoryId);
    setSelectedCrossSellingCategoryTypeId(item.sectionId);
  };

  const getLatestData = () => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(token);
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(token);
  }, []);

  useEffect(() => {
    let tableData = [];
    if (props.menuCategory) {
      for (let i = 0; i < props.menuCategory.length; i++) {
        if (props.menuCategory[i].cross_selling.category.length > 0) {
          let formData = {};
          formData.mainCategoryName = props.menuCategory[i].name;
          formData.mainCategoryId = props.menuCategory[i]._id;
          formData.sectionId = [];
          formData.sectionName = [];
          for (
            let j = 0;
            j < props.menuCategory[i].cross_selling.category.length;
            j++
          ) {
            formData.sectionName.push(
              props.menuCategory[i].cross_selling.category[j].name
            );
            formData.sectionId.push(
              props.menuCategory[i].cross_selling.category[j]._id
            );
          }
          // for (let j = 0; j < props.menuCategory.length; j++) {
          //   if (
          //     props.menuCategory[i].cross_selling.category.includes(
          //       props.menuCategory[j]._id
          //     )
          //   ) {
          //     formData.sectionName.push(props.menuCategory[j].name);
          //     formData.sectionId.push(props.menuCategory[j]._id);
          //   }
          // }
          tableData.push(formData);
        }
      }
      setCategory(tableData);
    }
  }, [props.menuCategory]);
  const displayMain = () => {
    return (
      <div
        className={`${
          !props.dash && `onboarding_process_screen-button-map`
        }  d-flex justify-content-between flex-column`}
      >
        <div>
          <TopTextReusableComponent
            headingText="Map Categories for Cross Selling"
            headingParagraph="(You can match categories by selecting categories, items in cross Selling category are proposed at the time of cart during ordering)"
          />
        </div>

        <div className="f20-500 mt-4">Cross Selling</div>
        <div className="f11-400 mb-4" style={{ color: "#9e9e9e" }}>
          Add all your Menu Categories to move ahead with the Menu Set Up
          Process
        </div>
        <div className="f14-500 mb-4">Category Type</div>
        <div className={"cuisine-main-padding-border"}>
          <div className="cuisine-main-padding d-flex flex-wrap">
            {props.menuCategory.map((cateogry, index) => (
              <Fragment key={index}>
                {!cateogry.is_temp_local ? (
                  <ReusableOnboardingMapButton
                    classsection={
                      selectedCategoryTypeId === cateogry._id
                        ? "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                        : "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                    }
                    //src={require("../../../../../../../assets/images/Icon/beverage.png")}
                    title={cateogry.name}
                    onClick={() => onChangeCategoryType(cateogry._id)}

                    // onClick={this.onSelectedServeLiquorArraySelector(icon)}
                  />
                ) : (
                  <> </>
                )}
              </Fragment>
            ))}

            {/* <ReusableOnboardingMapButton
      classsection={`mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type `}
      // src={require("../../../../../../../assets/images/Icon/beverage.png")}
      title={"Alcohol"}
    /> */}
          </div>
        </div>
        <hr />
        <div className="f14-500 mb-4">Cross Selling Category Type</div>
        <div className={"cuisine-main-padding-border"}>
          <div className="cuisine-main-padding d-flex flex-wrap">
            {filteredCategory.map((cateogry, index) => (
              <ReusableOnboardingMapButton
                key={index}
                classsection={
                  selectedCrossSellingCategoryTypeId.includes(cateogry._id)
                    ? "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                    : "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                }
                //src={require("../../../../../../../assets/images/Icon/beverage.png")}
                title={cateogry.name}
                onClick={() =>
                  onClickChangeCrossSellingCategoryType(cateogry._id)
                }
                // onClick={this.onSelectedServeLiquorArraySelector(icon)}
              />
            ))}
          </div>
        </div>
        <Media query="(min-width: 992px)">
          <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="btn-md btn btn-outline-secondary"
              buttonText="Cancel"
              link="/casual-fine-dining/menusetup"
            />
            <ReusableOnboardingButton
              buttonTitle="Save and Add Another"
              buttonClass="btn-md btn btn-danger btn-lg ml-3 "
              buttonText="Save and Add Another"
              buttonType="Submit"
              onClick={() => onClickSaveAndAddAnother()}
            />
            <ReusableOnboardingButton
              buttonTitle=" Proceed"
              buttonClass="btn-md btn btn-danger btn-lg ml-3 "
              buttonText="Proceed"
              buttonType="Submit"
              onClick={() => onClickProceed()}
            />
          </div>
        </Media>
        <Media query="(max-width: 991px)">
          <div className="onboarding-map-setup-screen-autodetect-button flex-wrap justify-content-center mt-5">
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass="btn-lg btn btn-danger btn-lg w-100"
              buttonText="Save and Add Another"
              buttonType="Submit"
            />
            <div className="pt-2 d-flex justify-content-center w-100">
              <ReusableOnboardingLink
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary w-100"
                buttonText="Cancel"
                link="/subscriptionhomeone"
              />

              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 w-100"
                buttonText="Proceed"
                buttonType="Submit"
              />
            </div>
          </div>
        </Media>
        <div className="f12-400 py-4">
          * Scroll down to see cross Selling Matches created
        </div>
        <Row className="align-items-center">
          <Col md={4} xs={3}>
            <div className="f14_700_HelveticaNeue py-2">Main Category</div>
          </Col>
          <Col md={3} xs={6}>
            <div className="f14_700_HelveticaNeue py-2">Section</div>
          </Col>
        </Row>
        <Row className="align-items-center border-bottom">
          {category.map((item, index) => (
            <>
              <Col md={4} xs={3}>
                <div className="f12-400 py-2">
                  {index + 1}) {item.mainCategoryName}
                </div>
              </Col>
              <Col md={5} xs={4}>
                <div className="f12-400 py-2">
                  {item.sectionName.toString()}
                </div>
              </Col>
              <Col md={3} xs={5}>
                <div className="d-flex align-items-center">
                  <IconButton className="mr-2">
                    <Image
                      src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                      alt="edit cross selling"
                      title="edit cross selling"
                      className="w-20px"
                      onClick={() => editCrossSelling(item)}
                    />
                  </IconButton>
                  <IconButton>
                    <Image
                      src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                      alt="delete cross selling"
                      title="delete cross selling"
                      className="w-20px"
                      onClick={() => onClickDeleteItem(item)}
                    />
                  </IconButton>
                </div>
              </Col>
            </>
          ))}
        </Row>
      </div>
    );
  };
  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          {console.log(props.menuCategory)}
          <div className="container-fluid">
            {props.dash ? (
              displayMain()
            ) : (
              <div className="row">
                <div
                  id="onboarding-scrollbar"
                  className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component sm-mb-100px"
                >
                  <Media query="(min-width: 992px)">
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        backButtonClicked={"/casual-fine-dining/menusetup"}
                        notDisplaProgressBar={true}
                      />
                    </div>
                  </Media>
                  <Media query="(max-width: 991px)">
                    <MobileTopHeader
                      link={true}
                      onLink={"/casual-fine-dining/menusetup"}
                    />
                  </Media>
                  {displayMain()}
                </div>
                <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                  <SliderReusableComponent
                    displayHamburger={true}
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
                  />
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      )}
      <Modal show={deleteItem} onHide={closeDeleteItem} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to delete cross selling ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={closeDeleteItem}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={(e) => handleDeleteItem(e)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

CrossSelling.propTypes = {
  auth: PropTypes.object.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  edit_category_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  menuCategory: state.onboarding.menuCategory,
  allSubscriptionData: state.onboarding.onboard_subscription_details,
  subscription: state.onboarding.onboard_subscription_details,
  subscriptionData:
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .menu_setup,
});

export default connect(mapStateToProps, {
  get_category_menu_setup,
  edit_category_menu_setup,
})(CrossSelling);

// import React, { useState, useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import { Image, Col, Row, Modal, Button } from "react-bootstrap";
// import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
// import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
// import {
//   ReusableOnboardingButton,
//   ReusableOnboardingLink,
//   ReusableOnboardingMapButton,
// } from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
// import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
// import { IconButton } from "@material-ui/core";
// import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
// import Media from "react-media";
// import { connect } from "react-redux";
// import { get_category_menu_setup } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
// import PropTypes from "prop-types";
// import { edit_category_menu_setup } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction";
// import Alert from "react-s-alert";
// import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
// const CrossSelling = (props) => {
//   let history = useHistory();
//   const [category, setCategory] = useState([]);
//   const [filteredCategory, setFilteredCategory] = useState([]);
//   const [selectedCategoryTypeId, setSelectedCategoryTypeId] = useState();
//   const [
//     selectedCrossSellingCategoryTypeId,
//     setSelectedCrossSellingCategoryTypeId,
//   ] = useState([]);

//   const onChangeCategoryType = (id) => {
//     setSelectedCategoryTypeId(id);
//     setSelectedCrossSellingCategoryTypeId([]);
//     let filteredData = props.menuCategory.filter((item) => {
//       return item._id !== id;
//     });
//     setFilteredCategory(filteredData);
//   };

//   const onClickChangeCrossSellingCategoryType = (id) => {
//     if (selectedCrossSellingCategoryTypeId.includes(id)) {
//       let filterData = selectedCrossSellingCategoryTypeId.filter((item) => {
//         return item !== id;
//       });
//       setSelectedCrossSellingCategoryTypeId(filterData);
//     } else {
//       setSelectedCrossSellingCategoryTypeId([
//         ...selectedCrossSellingCategoryTypeId,
//         id,
//       ]);
//     }
//   };

//   const [deleteItem, setDeleteItem] = useState(false);
//   const [deleteCategoryId, setDeleteCategoryId] = useState();
//   const closeDeleteItem = () => setDeleteItem(false);

//   const onClickDeleteItem = (item) => {
//     setDeleteCategoryId(item.mainCategoryId);
//     setDeleteItem(true);
//   };

//   const handleDeleteItem = (e) => {
//     e.preventDefault();
//     const token = props.auth.user.accessToken;
//     let formData = {};
//     formData.cross_selling = {
//       category: [],
//     };
//     let msg = "Cross Selling Deleted Sucessfully";
//     props.edit_category_menu_setup(
//       deleteCategoryId,
//       formData,
//       token,
//       onSuccess,
//       msg
//     );
//   };

//   const onSuccess = () => {
//     setSelectedCategoryTypeId();
//     setSelectedCrossSellingCategoryTypeId([]);
//     setFilteredCategory([]);
//     getLatestData();
//     closeDeleteItem();
//   };

//   const onClickSaveAndAddAnother = () => {
//     if (!selectedCategoryTypeId) {
//       Alert.error(`<h4> Please select category type</h4>`, {
//         position: "top-right",
//         effect: "bouncyflip",
//         beep: true,
//         html: true,
//         timeout: 3000,
//         offset: 35,
//       });
//     } else if (selectedCrossSellingCategoryTypeId.length === 0) {
//       Alert.error(`<h4> Please select cross selling category type</h4>`, {
//         position: "top-right",
//         effect: "bouncyflip",
//         beep: true,
//         html: true,
//         timeout: 3000,
//         offset: 35,
//       });
//     } else {
//       const token = props.auth.user.accessToken;
//       let formData = {};
//       formData.cross_selling = {
//         category: selectedCrossSellingCategoryTypeId,
//         category_type: selectedCategoryTypeId,
//       };
//       let msg = "Cross Selling Updated Sucessfully";
//       props.edit_category_menu_setup(
//         selectedCategoryTypeId,
//         formData,
//         token,
//         onSuccess,
//         msg
//       );
//     }
//   };

//   const onSuccesstakeToMenu = () => {
//     history.push("/casual-fine-dining/menusetup");
//   };

//   const onClickProceed = () => {
//     if (!selectedCategoryTypeId && category.length === 0) {
//       Alert.error(`<h4> Please select category type</h4>`, {
//         position: "top-right",
//         effect: "bouncyflip",
//         beep: true,
//         html: true,
//         timeout: 3000,
//         offset: 35,
//       });
//     } else if (
//       selectedCategoryTypeId &&
//       selectedCrossSellingCategoryTypeId.length === 0
//     ) {
//       Alert.error(`<h4> Please select cross selling category type</h4>`, {
//         position: "top-right",
//         effect: "bouncyflip",
//         beep: true,
//         html: true,
//         timeout: 3000,
//         offset: 35,
//       });
//     } else if (
//       selectedCategoryTypeId &&
//       selectedCrossSellingCategoryTypeId.length > 0
//     ) {
//       const token = props.auth.user.accessToken;
//       let formData = {};
//       formData.cross_selling = {
//         category: selectedCrossSellingCategoryTypeId,
//         category_type: selectedCategoryTypeId,
//       };
//       let msg = "Cross Selling Updated Sucessfully";
//       props.edit_category_menu_setup(
//         selectedCategoryTypeId,
//         formData,
//         token,
//         onSuccesstakeToMenu,
//         msg
//       );
//     } else if (category.length === 0) {
//       Alert.error(
//         `<h4> Please add atleast one cross selling category type</h4>`,
//         {
//           position: "top-right",
//           effect: "bouncyflip",
//           beep: true,
//           html: true,
//           timeout: 3000,
//           offset: 35,
//         }
//       );
//     } else {
//       onSuccesstakeToMenu();
//     }
//   };

//   const editCrossSelling = (item) => {
//     onChangeCategoryType(item.mainCategoryId);
//     setSelectedCategoryTypeId(item.mainCategoryId);
//     setSelectedCrossSellingCategoryTypeId(item.sectionId);
//   };

//   const getLatestData = () => {
//     const token = props.auth.user.accessToken;
//     props.get_category_menu_setup(token);
//   };

//   useEffect(() => {
//     const token = props.auth.user.accessToken;
//     props.get_category_menu_setup(token);
//   }, []);

//   useEffect(() => {
//     let tableData = [];
//     if (props.menuCategory) {
//       for (let i = 0; i < props.menuCategory.length; i++) {
//         if (props.menuCategory[i].cross_selling.category.length > 0) {
//           let formData = {};
//           formData.mainCategoryName = props.menuCategory[i].name;
//           formData.mainCategoryId = props.menuCategory[i]._id;
//           formData.sectionId = [];
//           formData.sectionName = [];
//           for (let j = 0; j < props.menuCategory.length; j++) {
//             if (
//               props.menuCategory[i].cross_selling.category.includes(
//                 props.menuCategory[j]._id
//               )
//             ) {
//               formData.sectionName.push(props.menuCategory[j].name);
//               formData.sectionId.push(props.menuCategory[j]._id);
//             }
//           }
//           tableData.push(formData);
//         }
//       }
//       setCategory(tableData);
//     }
//   }, [props.menuCategory]);

// return (
//   <React.Fragment>
//     {props.auth.loader ? (
//       <AmealioLoader />
//     ) : (
//       <React.Fragment>
//         <div className="container-fluid">
//           <div className="row">
//             <div
//               id="onboarding-scrollbar"
//               className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
//             >
//                <Media query="(min-width: 992px)">
//                <div className="col-12">
//                 <BackLogoIconButton
//                   displayBackText={true}
//                   displayArrow={true}
//                   backButtonClicked={"/casual-fine-dining/menusetup"}
//                   notDisplaProgressBar={true}
//                 />
//               </div>
//           </Media>
//           <Media query="(max-width: 991px)">
//             <MobileTopHeader
//               link={true}
//               onLink={"/casual-fine-dining/menusetup"}
//             />
//           </Media>

//               <div className="onboarding_process_screen-button-map d-flex justify-content-between flex-column">
//                 <div>
//                   <TopTextReusableComponent
//                     headingText="Map Categories for Cross Selling"
//                     headingParagraph="(You can match categories by selecting categories, items in cross Selling category are proposed at the time of cart during ordering)"
//                   />
//                 </div>

//                 <div className="f20-500 mt-4">Cross Selling</div>
//                 <div className="f11-400 mb-4" style={{ color: "#9e9e9e" }}>
//                   Add all your Menu Categories to move ahead with the Menu Set
//                   Up Process
//                 </div>
//                 <div className="f14-500 mb-4">Category Type</div>
//                 <div className={"cuisine-main-padding-border"}>
//                   <div className="cuisine-main-padding d-flex flex-wrap">
//                     {props.menuCategory.map((cateogry, index) => (
//                       <ReusableOnboardingMapButton
//                         key={index}
//                         classsection={
//                           selectedCategoryTypeId === cateogry._id
//                             ? "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
//                             : "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
//                         }
//                         //src={require("../../../../../../../assets/images/Icon/beverage.png")}
//                         title={cateogry.name}
//                         onClick={() => onChangeCategoryType(cateogry._id)}

//                         // onClick={this.onSelectedServeLiquorArraySelector(icon)}
//                       />
//                     ))}

//                     {/* <ReusableOnboardingMapButton
//                   classsection={`mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type `}
//                   // src={require("../../../../../../../assets/images/Icon/beverage.png")}
//                   title={"Alcohol"}
//                 /> */}
//                   </div>
//                 </div>
//                 <hr />
//                 <div className="f14-500 mb-4">
//                   Cross Selling Category Type
//                 </div>
//                 <div className={"cuisine-main-padding-border"}>
//                   <div className="cuisine-main-padding d-flex flex-wrap">
//                     {filteredCategory.map((cateogry, index) => (
//                       <ReusableOnboardingMapButton
//                         key={index}
//                         classsection={
//                           selectedCrossSellingCategoryTypeId.includes(
//                             cateogry._id
//                           )
//                             ? "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
//                             : "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
//                         }
//                         //src={require("../../../../../../../assets/images/Icon/beverage.png")}
//                         title={cateogry.name}
//                         onClick={() =>
//                           onClickChangeCrossSellingCategoryType(cateogry._id)
//                         }
//                         // onClick={this.onSelectedServeLiquorArraySelector(icon)}
//                       />
//                     ))}
//                   </div>
//                 </div>
//                 <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
//                   <ReusableOnboardingLink
//                     buttonTitle="Back Button"
//                     buttonClass="btn-lg btn btn-outline-secondary"
//                     buttonText="Cancel"
//                     link="/casual-fine-dining/menusetup"
//                   />
//                   <ReusableOnboardingButton
//                     buttonTitle="Save and Add Another"
//                     buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
//                     buttonText="Save and Add Another"
//                     buttonType="Submit"
//                     onClick={() => onClickSaveAndAddAnother()}
//                   />
//                   <ReusableOnboardingButton
//                     buttonTitle=" Proceed"
//                     buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
//                     buttonText="Proceed"
//                     buttonType="Submit"
//                     onClick={() => onClickProceed()}
//                   />
//                 </div>
//                 <div className="f12-400 py-4">
//                   * Scroll down to see cross Selling Matches created
//                 </div>
//                 <Row className="align-items-center">
//                   <Col md={4}>
//                     <div className="f14_700_HelveticaNeue py-2">
//                       Main Category
//                     </div>
//                   </Col>
//                   <Col md={3}>
//                     <div className="f14_700_HelveticaNeue py-2">Section</div>
//                   </Col>
//                 </Row>
//                 <Row className="align-items-center border-bottom">
//                   {category.map((item, index) => (
//                     <>
//                       <Col md={4}>
//                         <div className="f12-400 py-2">
//                           {index + 1}) {item.mainCategoryName}
//                         </div>
//                       </Col>
//                       <Col md={5}>
//                         <div className="f12-400 py-2">
//                           {item.sectionName.toString()}
//                         </div>
//                       </Col>
//                       <Col md={3}>
//                         <div className="d-flex align-items-center">
//                           <IconButton className="mr-2">
//                             <Image
//                               src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
//                               alt="edit cross selling"
//                               title="edit cross selling"
//                               className="w-20px"
//                               onClick={() => editCrossSelling(item)}
//                             />
//                           </IconButton>
//                           <IconButton>
//                             <Image
//                               src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
//                               alt="delete cross selling"
//                               title="delete cross selling"
//                               className="w-20px"
//                               onClick={() => onClickDeleteItem(item)}
//                             />
//                           </IconButton>
//                         </div>
//                       </Col>
//                     </>
//                   ))}
//                 </Row>
//               </div>
//               <hr />
//               <div className="f14-500 mb-4">Cross Selling Category Type</div>
//               <div className={"cuisine-main-padding-border"}>
//                 <div className="cuisine-main-padding d-flex flex-wrap">
//                   {filteredCategory.map((cateogry, index) => (
//                     <ReusableOnboardingMapButton
//                       key={index}
//                       classsection={
//                         selectedCrossSellingCategoryTypeId.includes(
//                           cateogry._id
//                         )
//                           ? "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
//                           : "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
//                       }
//                       //src={require("../../../../../../../assets/images/Icon/beverage.png")}
//                       title={cateogry.name}
//                       onClick={() =>
//                         onClickChangeCrossSellingCategoryType(cateogry._id)
//                       }
//                       // onClick={this.onSelectedServeLiquorArraySelector(icon)}
//                     />
//                   ))}
//                 </div>
//               </div>
//               <Media query="(min-width: 992px)">
//               <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
//                 <ReusableOnboardingLink
//                   buttonTitle="Back Button"
//                   buttonClass="btn-lg btn btn-outline-secondary"
//                   buttonText="Cancel"
//                   link="/casual-fine-dining/menusetup"
//                 />
//                 <ReusableOnboardingButton
//                   buttonTitle="Save and Add Another"
//                   buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
//                   buttonText="Save and Add Another"
//                   buttonType="Submit"
//                   onClick={() => onClickSaveAndAddAnother()}
//                 />
//                 <ReusableOnboardingButton
//                   buttonTitle=" Proceed"
//                   buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
//                   buttonText="Proceed"
//                   buttonType="Submit"
//                   onClick={() => onClickProceed()}
//                 />
//               </div>
//               </Media><Media query="(max-width: 991px)">
//             <div className="onboarding-map-setup-screen-autodetect-button flex-wrap justify-content-center mt-5">
//               <ReusableOnboardingButton
//                 buttonTitle="Next Button"
//                 buttonClass="btn-lg btn btn-danger btn-lg w-100"
//                 buttonText="Save and Add Another"
//                 buttonType="Submit"
//               />
//               <div className="pt-2 d-flex justify-content-center w-100">
//                 <ReusableOnboardingLink
//                   buttonTitle="Back Button"
//                   buttonClass="btn-lg btn btn-outline-secondary w-100"
//                   buttonText="Cancel"
//                   link="/subscriptionhomeone"
//                 />

//                 <ReusableOnboardingButton
//                   buttonTitle="Next Button"
//                   buttonClass="btn-lg btn btn-danger btn-lg ml-3 w-100"
//                   buttonText="Proceed"
//                   buttonType="Submit"
//                 />
//               </div>
//             </div>
//           </Media>
//               <div className="f12-400 py-4">
//                 * Scroll down to see cross Selling Matches created
//               </div>
//               <Row className="align-items-center">
//                 <Col  xs={3} md={4}>
//                   <div className="f14_700_HelveticaNeue py-2">
//                     Main Category
//                   </div>
//                 </Col>
//                 <Col  xs={6} md={3}>
//                   <div className="f14_700_HelveticaNeue py-2">Section</div>
//                 </Col>
//               </Row>
//               <Row className="align-items-center border-bottom">
//                 {category.map((item, index) => (
//                   <>
//                     <Col xs={3} md={4}>
//                       <div className="f12-400 py-2">
//                         {index + 1}) {item.mainCategoryName}
//                       </div>
//                     </Col>
//                     <Col xs={6} md={5}>
//                       <div className="f12-400 py-2">
//                         {item.sectionName.toString()}
//                       </div>
//                     </Col>
//                     <Col xs={3} md={3}>
//                       <div className="d-flex align-items-center">
//                         <IconButton className="mr-2">
//                           <Image
//                             src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
//                             alt="edit cross selling"
//                             title="edit cross selling"
//                             className="w-20px"
//                             onClick={() => editCrossSelling(item)}
//                           />
//                         </IconButton>
//                         <IconButton>
//                           <Image
//                             src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
//                             alt="delete cross selling"
//                             title="delete cross selling"
//                             className="w-20px"
//                             onClick={() => onClickDeleteItem(item)}
//                           />
//                         </IconButton>
//                       </div>
//                     </Col>
//                   </>
//                 ))}
//               </Row>
//             </div>
//             <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
//               <SliderReusableComponent
//                 displayHamburger={true}
//                 paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
//                 paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
//                 paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
//                 bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
//               />
//             </div>
//           </div>
//         </div>
//       </React.Fragment>
//     )}
//     <Modal show={deleteItem} onHide={closeDeleteItem} centered>
//       <Modal.Header className="py-0 pt-2 border-0" closeButton>
//         <Modal.Title></Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="f16-500">
//         Are you sure to delete cross selling ?
//       </Modal.Body>
//       <Modal.Footer className="justify-content-start border-0">
//         <Button
//           variant="outline-secondary"
//           className="btn-lg mr-4 px-5"
//           onClick={closeDeleteItem}
//         >
//           No
//         </Button>
//         <Button
//           variant="danger"
//           className="btn-lg px-5"
//           onClick={(e) => handleDeleteItem(e)}
//         >
//           Yes
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   </React.Fragment>
// );
// };

// CrossSelling.propTypes = {
//   auth: PropTypes.object.isRequired,
//   get_category_menu_setup: PropTypes.func.isRequired,
//   edit_category_menu_setup: PropTypes.func.isRequired,
// };

// const mapStateToProps = (state) => ({
//   auth: state.auth,
//   errors: state.errors.errors,
//   menuCategory: state.onboarding.menuCategory,
//   allSubscriptionData: state.onboarding.onboard_subscription_details,
//   subscription: state.onboarding.onboard_subscription_details,
//   subscriptionData:
//     state.onboarding.onboard_subscription_details.casual_dining_status &&
//     state.onboarding.onboard_subscription_details.casual_dining_status
//       .menu_setup,
// });

// export default connect(mapStateToProps, {
//   get_category_menu_setup,
//   edit_category_menu_setup,
// })(CrossSelling);
